/**
 * Purchase option → line item property.
 *
 * Keeps one hidden `properties[<label>]` input inside the real add-to-cart
 * form and fills it from the po3 selection: the subscription options carry
 * their text ("FeelMore App membership"), the one-time option disables the
 * input so nothing is sent. Shopify then prints the property under the
 * product in the cart, the checkout and the order — the only text the
 * checkout lets a theme add on this plan.
 *
 * Texts and the property name come from snippets/po3-includes.liquid.
 */
(function () {
  var node = document.querySelector('[data-po3-includes]');
  if (!node) return;

  var data;
  try {
    data = JSON.parse(node.textContent);
  } catch (e) {
    return;
  }
  if (!data || !data.label) return;

  var MARKER = 'data-fme-includes';

  // Same rule as purchase-options.js: Shop Pay's installments form shares
  // the action, only the real form lives inside <product-form>.
  function form() {
    return (
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]:not([id*="installment"])')
    );
  }

  function fieldset() {
    return document.querySelector('fieldset.po3');
  }

  function input() {
    var f = form();
    if (!f) return null;
    var el = f.querySelector('input[' + MARKER + ']');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + data.label + ']';
      el.setAttribute(MARKER, '');
      el.disabled = true; // disabled inputs are left out of the request
      f.appendChild(el);
    }
    return el;
  }

  function sync() {
    var el = input();
    var fs = fieldset();
    if (!el || !fs) return;
    var option = fs.querySelector('[name="purchase_option"]:checked');
    var text = option ? data[option.value] : '';
    if (text) {
      el.value = text;
      el.disabled = false;
    } else {
      el.value = '';
      el.disabled = true;
    }
  }

  function boot() {
    var fs = fieldset();
    var f = form();
    if (!fs || !f) return false;

    fs.addEventListener('change', sync);
    // Capture phase: runs before the form is serialized by anything else.
    f.addEventListener('submit', sync, true);
    var button = f.querySelector('[type="submit"]');
    if (button) button.addEventListener('click', sync, true);

    sync();
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (boot() || ++tries > 60) clearInterval(timer);
  }, 250);
})();
